import * as ActionsTypes from "../ActionTypes";


export const toggleModal = () => ({
  type: ActionsTypes.TOGGLE_MODAL,
});

